import scrollTo from './scrollTo';

let sectionJumper = $('.js-section-skip');

sectionJumper.on('click', event => {
  try {
    event.preventDefault();
    let target = $('.features-home');
    scrollTo(target, 350);
  } catch (e) {}
});
